"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _FormatterHelper = require("../../../helpers/FormatterHelper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var PrimaryInfo = _styledComponents["default"].div.withConfig({
  displayName: "TabletCellFormatter__PrimaryInfo",
  componentId: "k2mh4t-0"
})(["color:black;font-size:14px;"]);

var SecondaryInfo = _styledComponents["default"].div.withConfig({
  displayName: "TabletCellFormatter__SecondaryInfo",
  componentId: "k2mh4t-1"
})(["color:", ";font-size:12px;"], function (props) {
  return props.theme["dark-grey"];
});

var TabletCellFormatter = function TabletCellFormatter(_ref) {
  var primaryFormatter = _ref.primaryFormatter,
      secondaryFormatter = _ref.secondaryFormatter,
      other = _objectWithoutProperties(_ref, ["primaryFormatter", "secondaryFormatter"]); // Get the primary and secondary formatter, passing all props to the formatters.
  // The only props that are not sent is primaryFormatter and secondaryFormatter
  // Otherwise we get a cylical component error


  var pFormatter = (0, _FormatterHelper.getFormatter)(primaryFormatter, other);
  var sFormatter = (0, _FormatterHelper.getFormatter)(secondaryFormatter, other);
  var value = other.value,
      row = other.row,
      secondaryKey = other.secondaryKey;
  var primaryValue = value;

  if (secondaryKey !== undefined) {
    var secondaryValue = row[secondaryKey];
    return _react["default"].createElement(_react["default"].Fragment, null, pFormatter !== undefined && primaryValue !== null && primaryValue !== "" ? _react["default"].createElement(PrimaryInfo, null, pFormatter) : primaryValue !== null && primaryValue !== "" ? _react["default"].createElement(PrimaryInfo, null, primaryValue) : _react["default"].createElement(PrimaryInfo, null, "\xA0"), sFormatter !== undefined && secondaryValue !== null && secondaryValue !== "" ? _react["default"].createElement(SecondaryInfo, null, sFormatter) : secondaryValue !== null && secondaryValue !== "" ? _react["default"].createElement(SecondaryInfo, null, secondaryValue) : _react["default"].createElement(SecondaryInfo, null, "\xA0"));
  } else {
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(PrimaryInfo, null, pFormatter !== undefined ? pFormatter : value), _react["default"].createElement(SecondaryInfo, null, "\xA0"));
  }
};

TabletCellFormatter.displayName = "TabletCellFormatter";
TabletCellFormatter.propTypes = {
  value: _propTypes["default"].any,
  secondaryKey: _propTypes["default"].string,
  primaryFormatter: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  secondaryFormatter: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  row: _propTypes["default"].object
};
var _default = TabletCellFormatter;
exports["default"] = _default;